import { sidebarSize, topbarSize } from '../../../../../../../constants/sizes';
import { appConfig } from '../../../../../../../config/customization';

export default {
  container: {
    height: `calc(100vh - ${topbarSize}px)`,
    width: `calc(100vw - ${sidebarSize}px)`
  },
  title: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '35px 40px 15px',
    width: '100%',
    boxSizing: 'border-box',
    borderBottom: `2px solid ${appConfig.colors.topbarColor}`,
    textAlign: 'left'
  }
};
